import React, { Component } from 'react';
import Page from '~/components/page/page';
import TitleBar from '~/components/titleBar/titleBar';
import Greeting from '~/containers/greeting/greeting';
import TodaysAgendaList from '~/containers/todaysAgendaList/todaysAgendaList';
import AllUpcomingLotsGraph from '~/containers/allUpcomingLotsGraph/allUpcomingLotsGraph';
import ProductsInProgressCard from '~/containers/productsInProgressCard/productsInProgressCard';

export default class HomePage extends Component {
  render() {
    return (
      <Page>
        <TitleBar title={<Greeting />} />
        <AllUpcomingLotsGraph />
        <ProductsInProgressCard />
        <TodaysAgendaList />
      </Page>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/home/home.jsx